// Helpers
import axios from 'axios'

import { userHelper } from './userHelper'

import { saveAs } from 'file-saver'

import _ from 'lodash'

import { SERVICE_CATEGORY } from './constants'

export const serviceHelper = {
  authHeader,
  createApiClient,
  handleError,
  handleResponse,
  handleStatus,
  handleFileDownload,
  statusIsUnauthorized,
  getRequestHeader,
  splitServiceAdditional
}

function authHeader () {
  const userData = JSON.parse(localStorage.getItem('userData'))
  if (userData && userData.professional.token) {
    return { Authorization: userData.professional.token }
  } else {
    return {}
  }
}

function getRequestHeader (headers = {}) {
  const token = authHeader()
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    ...token,
    ...headers
  }
}

function createApiClient (baseURL) {
  const instance = axios.create({
    baseURL,
    headers: getRequestHeader()
  })

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const isUnauthorized = error?.response?.status === 401
      const hasActiveSession = !!error?.config?.headers?.Authorization

      if (isUnauthorized && hasActiveSession) {
        userHelper.logoutUser()
        return new Promise(() => {})
      }

      return Promise.reject(error)
    }
  )

  return instance
}

function handleError (dispatch, error) {
  if (error === undefined || error === null) return
  const { status } = error
  const userIsUnauthorized = statusIsUnauthorized(status)
  if (userIsUnauthorized) userHelper.logoutUser(dispatch)
}

function handleResponse (response) {
  return response.json()
}

function handleStatus (response) {
  if (response.ok) return Promise.resolve(response)
  if (response.status === 401 || response.status === 406) { return Promise.reject(response) }
  return Promise.reject(response.json())
}

function handleFileDownload (response) {
  if (response !== undefined && response !== null) {
    const blob = new Blob([response], { type: 'octet/stream;charset=utf-8' })
    saveAs(blob, 'relatório.csv')
  }

  return true
}

function statusIsUnauthorized (statusTarget) {
  if (statusTarget === 401 || statusTarget === 403) return true
  return false
}

function splitServiceAdditional (services) {
  const filteredServices = services.filter((service) => service.category !== SERVICE_CATEGORY.PERSONAL_PET && !service.package)
  const splitedServices = _.partition(filteredServices, (service) => {
    return !!service.additional
  })
  return {
    mainServices: splitedServices[1],
    additionalServices: splitedServices[0]
  }
}
